import { render, staticRenderFns } from "./EntityDetailMetric.vue?vue&type=template&id=466368ff&scoped=true"
import script from "./EntityDetailMetric.vue?vue&type=script&lang=ts"
export * from "./EntityDetailMetric.vue?vue&type=script&lang=ts"
import style0 from "./EntityDetailMetric.vue?vue&type=style&index=0&id=466368ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466368ff",
  null
  
)

export default component.exports